// ======================================================================
// File Name       : messageThread
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import $ from 'jquery';
import * as ActionTypes from '../constants/actionTypes/messageThread';
import { mapUserSecernIdWithGroupName } from '../utils/UserUtils';
import { MAX_MESSAGE_NUM } from '../constants/MessageThreadContants';
import store from '../store';

const initialState = {
  receiveMessages: {
    allMessageIds: [],
    byMessageIds: {},
  },
  storedUsers: {},
  edittingUsers: {
    bySecernIds: {},
    allSecernIds: [],
  },
  groupInfo: {
    bySecernId: {},
    allSecernIds: [],
  },
  groupRelationList: [],
  messageInfo: {},
  userListOnDialog: [],
  messageThreadDetailUserList: [],
  userListRecordNum: 0,
  recordNumOnDialog: 0,
  recordNum: 0,
  structure: {},
  structureList: [],
  structureRecordNum: 0,
  filteredStructureRecordNum: 0,
  rootMessageInfo: {},
  isLoadMore: false,
  isDelete: false,
  reloadChat: false,
};

export default function messageThread(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.RECEIVE_MESSAGE_LIST: {
      const { resData, userListToStore } = action;
      const { storedUsers } = state;
      userListToStore.reduce((acc, cur) => {
        if (cur.userSecernId) {
          storedUsers[cur.userSecernId] = cur;
        }
        return acc;
      }, []);
      const { recordNum, messageList } = resData;
      const receiveMessages = messageList.reduce(
        (acc, cur) => {
          if (cur.messageIdAuto) {
            acc.allMessageIds.push(cur.messageIdAuto);
            acc.byMessageIds[cur.messageIdAuto] = cur;
          }
          return acc;
        },
        {
          allMessageIds: [],
          byMessageIds: {},
        },
      );
      return {
        ...state,
        receiveMessages,
        storedUsers,
        recordNum,
      };
    }

    case ActionTypes.ADD_USER_TO_LIST: {
      const { userListToAdd } = action;
      const { storedUsers, groupRelationList, groupInfo } = state;
      const userState = store.getState().user;
      let edittingUsers = {
        bySecernIds: {},
        allSecernIds: [],
      };
      let groupListCheck = groupInfo;
      if (userState.groupInfoAll && userState.groupInfoAll.allSecernIds && userState.groupInfoAll.allSecernIds.length) {
        groupListCheck = userState.groupInfoAll;
      }
      if (userListToAdd && storedUsers) {
        edittingUsers = userListToAdd.reduce(
          (acc, cur) => {
            if (storedUsers[cur]) {
              storedUsers[cur].groupNames = mapUserSecernIdWithGroupName(
                cur,
                groupRelationList,
                groupListCheck,
              );
              acc.bySecernIds[cur] = storedUsers[cur];
              acc.allSecernIds.push(cur);
            }
            return acc;
          },
          {
            bySecernIds: {},
            allSecernIds: [],
          },
        );
      }
      return {
        ...state,
        edittingUsers,
      };
    }

    case ActionTypes.REMOVE_USER_FROM_LIST: {
      const { userSecernId } = action;
      const { edittingUsers } = state;
      if (userSecernId && edittingUsers) {
        if (edittingUsers.bySecernIds && edittingUsers.bySecernIds[userSecernId]) {
          delete edittingUsers.bySecernIds[userSecernId];
        }
        if (edittingUsers.allSecernIds) {
          const pos = edittingUsers.allSecernIds.indexOf(userSecernId);
          if (pos > -1) {
            edittingUsers.allSecernIds.splice(pos, 1);
          }
        }
      }
      return {
        ...state,
        edittingUsers,
      };
    }

    case ActionTypes.RESET_EDITTING_USERS: {
      const edittingUsers = {
        bySecernIds: {},
        allSecernIds: [],
      };
      return {
        ...state,
        edittingUsers,
      };
    }

    case ActionTypes.STORE_INIT_DATA: {
      const { userSearchResult: { userList, recordNum }, groupRelationList, groupList } = action;
      const { storedUsers } = state;
      const userState = store.getState().user;
      let groupInfo = {
        bySecernId: {},
        allSecernIds: [],
      };
      let newUserList = [];
      if (groupList && groupList.length) {
        groupInfo = groupList.reduce(
          (acc, cur) => {
            if (cur.groupSecernId) {
              const { groupSecernId, parentGroupSecernId } = cur;
              cur.child = (acc.bySecernId[groupSecernId] || {}).child || [];
              acc.bySecernId[groupSecernId] = cur;
              convetNewStructure(acc, groupSecernId, parentGroupSecernId);
            }
            return acc;
          },
          {
            bySecernId: {},
            allSecernIds: [],
          },
        );
      }
      let groupListCheck = groupInfo;
      if (userState.groupInfoAll && userState.groupInfoAll.allSecernIds && userState.groupInfoAll.allSecernIds.length) {
        groupListCheck = userState.groupInfoAll;
      }
      if (userList) {
        newUserList = userList.reduce((acc, cur) => {
          cur.groupNames = mapUserSecernIdWithGroupName(
            cur.userSecernId,
            groupRelationList,
            groupListCheck,
          );
          storedUsers[cur.userSecernId] = cur;
          acc.push(cur);
          return acc;
        }, []);
      }
      return {
        ...state,
        storedUsers,
        userListOnDialog: newUserList,
        recordNumOnDialog: recordNum,
        groupRelationList,
        groupInfo,
        groupList,
      };
    }

    case ActionTypes.STORE_USER_SEARCH_RESULT: {
      const { userSearchResult: { userList, recordNum }, newGroupRelationList } = action;
      const { storedUsers, groupRelationList, groupInfo } = state;
      const userState = store.getState().user;
      const newGroupRelationItems = groupRelationList.concat(newGroupRelationList);
      let newUserList = [];
      let groupListCheck = groupInfo;
      if (userState.groupInfoAll && userState.groupInfoAll.allSecernIds && userState.groupInfoAll.allSecernIds.length) {
        groupListCheck = userState.groupInfoAll;
      }
      if (userList) {
        newUserList = userList.reduce((acc, cur) => {
          cur.groupNames = mapUserSecernIdWithGroupName(
            cur.userSecernId,
            newGroupRelationItems,
            groupListCheck,
          );
          storedUsers[cur.userSecernId] = cur;
          acc.push(cur);
          return acc;
        }, []);
      }
      return {
        ...state,
        storedUsers,
        userListOnDialog: newUserList,
        recordNumOnDialog: recordNum,
        groupRelationList: newGroupRelationItems,
      };
    }

    case ActionTypes.RECEIVE_MESSAGE_THREAD_INFO: {
      const {
        messageInfo,
        rootMessageRelationList,
        userListToStore,
        groupRelationList,
        groupList,
        userListRecordNum,
      } = action;
      const { storedUsers } = state;

      const groupInfo = groupList.reduce(
        (acc, cur) => {
          if (cur.groupSecernId) {
            const { groupSecernId, parentGroupSecernId } = cur;
            cur.child = (acc.bySecernId[groupSecernId] || {}).child || [];
            acc.bySecernId[groupSecernId] = cur;
            convetNewStructure(acc, groupSecernId, parentGroupSecernId);
          }
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );
      const messageRelationList = rootMessageRelationList.reduce((acc, cur) => {
        if (cur && cur.userSecernId) {
          acc[cur.userSecernId] = cur;
        }
        return acc;
      }, {});
      const messageThreadDetailUserList = userListToStore.reduce((acc, cur) => {
        if (cur.userSecernId) {
          cur.groupNames = mapUserSecernIdWithGroupName(
            cur.userSecernId,
            groupRelationList,
            groupInfo,
          );
          cur.createdAt = messageRelationList[cur.userSecernId]
            ? messageRelationList[cur.userSecernId].createdAt
            : '';
          storedUsers[cur.userSecernId] = cur;
          acc.push(cur);
        }
        return acc;
      }, []);

      return {
        ...state,
        messageInfo,
        storedUsers,
        rootMessageRelationList,
        groupRelationList,
        groupList,
        groupInfo,
        userListRecordNum,
        messageThreadDetailUserList,
      };
    }

    case ActionTypes.RECEIVE_MESSAGE_THREAD_USER_PAGING: {
      const {
        rootMessageRelationList,
        userListToStore,
        groupRelationList,
        userListRecordNum,
      } = action;
      const { storedUsers, groupInfo } = state;

      const messageThreadDetailUserList = userListToStore.reduce((acc, cur) => {
        if (cur.userSecernId) {
          cur.groupNames = mapUserSecernIdWithGroupName(
            cur.userSecernId,
            groupRelationList,
            groupInfo,
          );
          storedUsers[cur.userSecernId] = cur;
          acc.push(cur);
        }
        return acc;
      }, []);

      return {
        ...state,
        storedUsers,
        rootMessageRelationList,
        groupRelationList,
        groupInfo,
        userListRecordNum,
        messageThreadDetailUserList,
      };
    }

    case ActionTypes.RECEIVE_INIT_MESSAGE_STRUCTURE: {
      const { structure, rootMessageInfo } = action;
      let structureList = [];
      let structureRecordNum = 0;
      let newStructureList = [];
      let filteredStructureRecordNum = 0;
      if (structure && structure.messageList && structure.messageList.length) {
        structureRecordNum = structure.recordNum;
        structure.messageList.sort((a, b) => {
          if (!a.createdAt || !b.createdAt) {
            return 0;
          }
          const mA = moment(a.createdAt);
          const mB = moment(b.createdAt);
          return mA.diff(mB);
        });
        structureList = $.extend(true, [], structure.messageList);
        newStructureList = structureList;
        filteredStructureRecordNum = newStructureList.length;
        newStructureList = newStructureList.slice(0 - MAX_MESSAGE_NUM);
      }
      return {
        ...state,
        structure,
        rootMessageInfo,
        structureList: newStructureList,
        structureRecordNum,
        filteredStructureRecordNum,
        isLoadMore: false,
        isDelete: false,
        reloadChat: !state.reloadChat,
      };
    }

    case ActionTypes.LOAD_MORE_MESSAGE: {
      const { structureList, structure } = state;
      const olderStructureList = $.extend(true, [], structure.messageList);
      const sliceLength = 0 - (structureList.length + MAX_MESSAGE_NUM);
      const newStructureList = olderStructureList.slice(sliceLength);
      return {
        ...state,
        structureList: newStructureList,
        isLoadMore: true,
        isDelete: false,
      };
    }

    case ActionTypes.RELOAD_CHAT_AFTER_DELETE: {
      const { structureList, structure } = state;
      const { messageInfo } = action;
      if (structure && structure.messageList) {
        const deletedMessageIndex = structure.messageList.findIndex(
          message => message.messageIdAuto === messageInfo.messageIdAuto,
        );
        if (deletedMessageIndex > -1) {
          structure.messageList[deletedMessageIndex].messageDeletedFlag = 1;
        }
      }
      if (structureList && structureList.length) {
        const deletedMessageIndex = structureList.findIndex(
          message => message.messageIdAuto === messageInfo.messageIdAuto,
        );
        if (deletedMessageIndex > -1) {
          structureList[deletedMessageIndex].messageDeletedFlag = 1;
        }
      }
      const filteredStructureRecordNum =
        structure && structure.messageList ? structure.messageList.length : 0;
      const newStructureList = [...structureList];
      return {
        ...state,
        structureList: newStructureList,
        filteredStructureRecordNum,
        isLoadMore: false,
        isDelete: true,
        reloadChat: !state.reloadChat,
      };
    }

    case ActionTypes.RECEIVE_MESSAGE_STRUCTURE: {
      const { structure } = action;
      let structureList = [];
      let newStructureList = [];
      let structureRecordNum = 0;
      let filteredStructureRecordNum = 0;
      if (structure && structure.messageList) {
        structureRecordNum = structure.recordNum;
        structure.messageList.sort((a, b) => {
          if (!a.createdAt || !b.createdAt) {
            return 0;
          }
          const mA = moment(a.createdAt);
          const mB = moment(b.createdAt);
          return mA.diff(mB);
        });
        structureList = $.extend(true, [], structure.messageList);
        filteredStructureRecordNum = structureList.length;
        newStructureList = structureList.slice(0 - MAX_MESSAGE_NUM);
      }
      return {
        ...state,
        structure,
        structureList: newStructureList,
        structureRecordNum,
        filteredStructureRecordNum,
        isLoadMore: false,
        isDelete: false,
        reloadChat: !state.reloadChat,
      };
    }

    case ActionTypes.REMOVED_USER_IN_DIALOG: {
      return {
        ...state,
        userListOnDialog: [],
      };
    } 
    case ActionTypes.REMOVE_ALL_USER_FROM_LIST: {
      return {
        ...state,
        edittingUsers: {
          allSecernIds: [],
          bySecernIds: {},
        },
      };
    }

    // Step 10.0.0 START
    case ActionTypes.MESSAGE_THREAD_RESET_DATA: {
      return {
        ...state,
        ...initialState,
      };
    }
    // Step 10.0.0 END

    default: {
      return state;
    }
  }
}

function filterDeleteMessage(structureList) {
  if (!structureList || !structureList.length) {
    return [];
  }
  return structureList.reduce((acc, cur) => {
    if (!cur.messageDeletedFlag) {
      acc.push(cur);
    }
    return acc;
  }, []);
}

function convetNewStructure(structures, groupSecernId, parentGroupSecernId) {
  const setNewChild = (targetSecernId, childSecernId) => {
    const target = structures.bySecernId[targetSecernId] || { child: [] };
    const child = (childSecernId && [...(target.child || []), childSecernId]) || [];
    // overide structures.bySecernId[targetSecernId]
    structures.bySecernId[targetSecernId] = { ...target, child };
  };

  parentGroupSecernId
    ? setNewChild(parentGroupSecernId, groupSecernId)
    : structures.allSecernIds.push(groupSecernId);
}
